/*
 * Appstle plan sync (fallback). The Appstle widget renders its selling_plan
 * radios outside the theme's product <form>. Mirror the checked plan into a
 * hidden input inside the main product form so the theme's Add to cart posts
 * it. Quantity is NOT touched: pack size lives in the variant, quantity is the
 * customer's own choice (standard Shopify model).
 */
(function () {
  if (window.__misooraPlanSyncInit) return;
  window.__misooraPlanSyncInit = true;

  function checkedPlan() {
    var el = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    if (!el) return null;
    var v = el.value;
    return /^\d+$/.test(v) && Number(v) > 0 ? v : null;
  }

  function mainForms() {
    var out = [];
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) {
      var id = f.getAttribute('id') || '';
      if (id.indexOf('quick-view') >= 0) return;
      if (/(__main|sticky|__product_highlight)/.test(id)) out.push(f);
    });
    return out;
  }

  function sync() {
    var plan = checkedPlan();
    mainForms().forEach(function (form) {
      var el = form.querySelector('input.misoora-selling-plan');
      if (plan) {
        if (!el) {
          el = document.createElement('input');
          el.type = 'hidden';
          el.name = 'selling_plan';
          el.className = 'misoora-selling-plan';
          form.appendChild(el);
        }
        el.value = plan;
      } else if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
  }

  var P = 'AppstleSubscription:SubscriptionWidget:';
  ['SellingPlanSelected', 'sellingPlanChanged', 'SellingPlanDeSelected', 'SellingPlanRemoved', 'widgetInitialised']
    .forEach(function (ev) { document.addEventListener(P + ev, sync); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'selling_plan') sync();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('button[name="add"], .add_to_cart_button')) sync();
  }, true);
  [300, 700, 1500, 3000].forEach(function (t) { setTimeout(sync, t); });
})();
